const INITDEVICE = 'INITDEVICE'
const STORAGE = window.localStorage

const storage = {
  set (type, val) {
    let getVal = STORAGE.getItem(INITDEVICE)
    if (getVal) {
      getVal = JSON.parse(getVal)
    } else {
      getVal = {}
    }
    getVal[type] = val
    window.localStorage.setItem(INITDEVICE, JSON.stringify(getVal))
  },
  get (type) {
    let val
    try {
      val = JSON.parse(STORAGE.getItem(INITDEVICE))
    } catch (e) {
      val = {}
    }
    return val && val[type]
  }
}

export default storage
